"use strict";
exports.__esModule = true;
function configurable(targetFunction, config) {
    for (var item in config) {
        (function (item) {
            targetFunction[item] = function (value) {
                if (!arguments.length) {
                    return config[item];
                }
                config[item] = value;
                return targetFunction;
            };
        })(item);
    }
}
exports.configurable = configurable;
